import home from './routes/home'
import certificate from './routes/certificate'
import node from './routes/node'
import blockchain from './routes/blockchain'
import drive from './routes/drive'

import system from './routes/system'
import camanage from './routes/camanage'
import configmanage from './routes/configmanage'
import excellent from './routes/excellent'
import datamigration from './routes/datamigration'
import crossChain from './routes/crossChain'
import oracleManagement from './routes/oracleManagement'
import contractdetector from './routes/contractdetector'
import spvlightnodes from './routes/spvlightnodes'
// import agileTest from './routes/agileTest'

import expansionDemo from './routes/expansionDemo'
import privacy from './routes/privacy'
import encryption from './routes/encryption'

let constantRouterMap = [
  {
    path: '/',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    redirect: '/login',
    hidden: true
  },
  // 401
  {
    path: '/401',
    component: resolve => require(['@/views/401'], resolve),
    hidden: true
  },
  // 404
  {
    path: '/404',
    component: resolve => require(['@/views/404'], resolve),
    hidden: true
  },

  // login
  {
    path: '/login',
    component: resolve => require(['@/views/login'], resolve),
    hidden: true
  },
  // 首页图表

  {
    path: '/dataAnalysis',
    component: resolve => require(['@/views/dataAnalysis'], resolve),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  ...home,
  ...camanage,
  ...certificate,
  ...node,
  ...blockchain,
  ...drive,
  ...system,
  ...configmanage,
  ...excellent,
  ...privacy,
  ...encryption,
  ...expansionDemo,
  ...datamigration,
  ...crossChain,
  ...spvlightnodes,
  ...oracleManagement,
  ...contractdetector,
  // ...agileTest
]

export default constantRouterMap
